import { useSelector } from 'react-redux';

import { subscriptionSelectors } from '../../../../store/modules/subscription';

const useSubscriptionChangeState = () => {
  const subscriptionChange = useSelector(
    subscriptionSelectors.selectSubscriptionChange
  );

  const isPending = useSelector(
    subscriptionSelectors.selectSubscriptionChangePending
  );

  const isError = useSelector(
    subscriptionSelectors.selectSubscriptionChangeErrorStatus
  );

  return !isError && !isPending ? subscriptionChange : null;
};

export default useSubscriptionChangeState;
